import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { Button, DialogActions } from "@mui/material";
import { useModalManager } from "./store";
import { FullScreenDialog } from "@/components/MediaSelector/MediaTypeTabPanel/FullScreenDialog";
import { ModalWrapper } from "@/components/MediaSelector/MediaTypeTabPanel/ModalWrapper";
import EditMediaView from "@/views/cms/EditorView/EditMediaView";

export const EditMediaViewModal: FC = () => {
  const currentModalId = useModalManager((s) => s.editMediaView.currentModalId);
  const modal = useModalManager((s) => s.editMediaView.modals[currentModalId]);
  const isOpen = useModalManager((s) => s.editMediaView.isOpen);
  const { t } = useTranslation("common");

  const onCloseModal = () => {
    if (!modal?.props.isDirty || window.confirm(t("generic.unsavedChangesMessage"))) modal?.meta.onClose();
  };

  return (
    <FullScreenDialog maxWidth={"xl"} fullWidth open={isOpen} onClose={onCloseModal} scroll={"paper"}>
      <ModalWrapper>
        <ModalWrapper>{modal?.props && <EditMediaView modalEditor {...modal.props} />}</ModalWrapper>
      </ModalWrapper>
      <DialogActions>
        <Button type="button" color="primary" variant="contained" onClick={onCloseModal}>
          {t("generic.close")}
        </Button>
      </DialogActions>
    </FullScreenDialog>
  );
};
